<template>
  <div>

    <ed-modal 
      :modal="showConfig" 
      :title="(consulta ? 'CONFIGURAÇÕES DA CONSULTA Nº '+consulta.id_con+' - '+consulta.funcionario.nome : '')"
      width="90%"
    >
      <div slot="modal-content" v-if="consulta">
        <Config :show="showConfig" :consulta="consulta"/>
      </div>
    </ed-modal>

    <TableView
      :onSearch="getConsulta"
      :onFilter="getConsulta"
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="config.loading.table"
      :filterBadge="filterBadge"
    >
      <div slot="table-filter-content">
				<ed-form 
					:data="formFilter" 
					:config="config" 
					:response="response" 
					:itens="filterItems"
				/>
			</div>
    </TableView>
  </div>
</template>

<script>

import Rest from "common/rest";
import EdForm from "common/form";
import EdModal from "common/modal";
import TableView from 'common/table'
import FilterItems from './_form/consulta-filtro'

import Config from './configuracao/index'


export default {
  components: {TableView,EdForm,EdModal,Config},
  mixins: [Rest],
  watch:{
    'formFilter.id_empresa'(){
      this.getFuncionario();

      this.config.disabled.id_funcionario = (this.formFilter.id_empresa ? false : true);
      this.formFilter.id_funcionario = null;
    },
  },
  data() {
    return {
      config:{
        tipo:[46,53],
        tipo_exclude:[68],
        click:{
          id_empresa:this.getEmpresa,
          id_funcionario:this.getFuncionario,
        },
        list:{
          id_empresa:[],
          id_funcionario:[],
        },
        loading:{
          id_empresa:false,
          id_funcionario:false,
          table:false,
        },
        disabled:{
          id_funcionario:true,
          id_fdt:true,
        }
      },
      formFilter:{
        id_empresa:null,
        id_funcionario: null,
        id_tipo_status: ['54','55','69','68','70'],
        id_tipo_aso: [],
        created_at:[],
        agendamento_at:[],
        deleted:0
      },
      filterBadge:0,
      showConfig:false,
      consulta:null,
      pagination:{},
      response:{},
      filterItems:[],
      tableData: [],
      tableHead: [
          {
            key: 'id_con',
            sortable: true,
            label: 'Consulta',

          },
          {
            key: 'empresa',
            sortable: true,
            label: 'Empresa',

          },
          {
            key: 'funcionario',
            sortable: true,
            label: 'Funcionário',
          },
          {
            key: 'funcao',
            sortable: true,
            show_tipo_aso:true,
            label: 'Função',
          },
          {
            key: 'data_age',
            sortable: true,
            label: 'Agendamento',
          },
          {
            key: 'tipo_status',
            sortable: true,
            label: 'Status',
          }
      ]
    };
  },

  created() {
  },

  mounted(){
    this.filterItems = FilterItems;
    this.getConsulta();
    this.getEmpresa();

    this.$events.on('consulta-liberado', eventData => {
      this.getConsulta();
    });
  },

  methods: {


    onEdit(data){
      this.toRoute({name: 'credenciada.consulta.edt',params:{consulta:data.id}});
    }, 

    onConfig(data){
      this.consulta = data;
      this.showConfig = !this.showConfig
    }, 


    onGerarConsulta(data){

      var label = data.funcionario.nome, self = this;

      this.$confirm('O sistema vai gerar uma consulta definitiva para o funcionário '+label+'. Deseja continuar?', 'Atenção', {
      type: 'warning'
      })
      .then(() => {
        self.config.loading.table = true;

        self.get('consulta/externa/'+data.id+'/gerar').then((result)=>{
          result = result[0];
          
          self.config.loading.table = false;

          if(result.status == 200){
            self.onEdit(data);
          }
          else{
            self.edAlert(result.msg,'error');
          }
        });
      })
    },

    getEmpresa: function(_search){

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get('/empresa',{search:_search}).then((result)=>{

        result = result[0];

        this.config.loading.id_empresa = false;

        if(result.status == 200){
          this.config.list.id_empresa = result.data.data;
        }
      });

    },

    getFuncionario: function(_search){

      if(!this.formFilter.id_empresa)return; 

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/empresa/funcionario/'+this.formFilter.id_empresa,{search:_search}).then((result)=>{

        result = result[0];

        this.config.loading.id_funcionario = false;

        if(result.status == 200){
          this.config.list.id_funcionario = result.data.data;
        }
      });

    },

    getConsulta(search,page,pagination) {

    this.config.loading.table = true;

    if(this.formFilter.agendamento_at.length != 2){
      var
      hoje = this.toDate(null,true),
      ontem = this.toDate(this.addDate(-60,null,'D'),true),
      amanha = this.toDate(this.addDate(0,null,'D'),true);

      this.formFilter.agendamento_at = [ontem,amanha];
    }

    this.filterBadge = (
      (this.formFilter.id_funcionario ? 1 : 0)+
      (this.formFilter.id_empresa ? 1 : 0)+
      (this.formFilter.created_at.length>0 ? 1 : 0)+
      (this.formFilter.agendamento_at.length>0 ? 1 : 0)+
      (this.formFilter.id_tipo_aso.length)+
      (this.formFilter.id_tipo_status.length)
    );
        
		this.get("consulta/externa",{search:search,page:page,pagination:pagination,filter:this.formFilter}).then(result => {
      result = result[0];
      
      this.config.loading.table = false;
      this.response = result;

      var data = [], tableData = [], pagination = {};

			if(result.status == 200) {

        data = result.data.data;
 
        for (var i = 0; i < data.length; i++) {

          var item = {
            id: data[i].id,
            id_con: (data[i].id_con ? data[i].id_con : '---'),
            empresa: (data[i].empresa ? data[i].empresa.nome : null),
            funcionario: (data[i].funcionario ? data[i].funcionario.nome : null),
            funcao: (data[i].funcao ? data[i].funcao.nome : null),
            ghe: (data[i].ghe ? data[i].ghe.ghe+' ('+data[i].ghe.descricao+')' : null),
            tipo_consulta: (data[i].tipo_aso ? data[i].tipo_aso.descricao : null),
            tipo_status: (data[i].tipo_status ? data[i].tipo_status.descricao : null),
            data_age: this.toDate(data[i].data_age,true),
            _data: data[i],
            options:{
              disable_edit: (data[i].deleted_at ? true : false),
              disable_delete: (data[i].id_con || data[i].deleted_at ? true : false),
            },
            buttons : []
          };

          if(!data[i].deleted_at && data[i].tipo_status.id == 54){
            item.buttons.push(
              {
                color: 'success',
                icon : 'fa fa-paper-plane',
                title: 'Iniciar Atendimento',
                click : this.onGerarConsulta

              }
            );
          }
          else if(!data[i].deleted_at){
            item.buttons.push(
              {
                color: 'primary',
                icon : 'fa fa-pencil-square-o',
                title: 'Editar Consulta',
                click : this.onEdit

              }
            );

            if(data[i].id_con && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58){
              item.buttons.push(
                {
                  color: 'success',
                  icon : 'fa fa-cogs',
                  title: 'Ver Opções desta Consulta',
                  click : this.onConfig

                }
              );
            }
          }
          tableData.push(item);
        }

        pagination = result.data;
      } 
      
       this.tableData = tableData;
       this.pagination = pagination;
		});
    },
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?344fbcd6